var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconGiftcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.275,
    height: 16.016,
    viewBox: "0 0 25.275 16.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{font-size:8px;font-family:SDJeongche830i, Sandoll Jeongche;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1380 -515.089)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380 515.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.5,93.782H21a.37.37,0,0,0,0,.74h2.5a1.035,1.035,0,0,1,1.034,1.034v12.467a1.035,1.035,0,0,1-1.034,1.034H1.775A1.035,1.035,0,0,1,.74,108.023V103.2l8.674-8.674H19.523a.37.37,0,1,0,0-.74H1.775A1.777,1.777,0,0,0,0,95.557v12.467A1.777,1.777,0,0,0,1.775,109.8H23.5a1.777,1.777,0,0,0,1.775-1.775V95.557A1.777,1.777,0,0,0,23.5,93.782ZM.74,95.557a1.035,1.035,0,0,1,1.034-1.034H5.513L.74,99.3Zm0,4.786,5.82-5.82H8.367L.74,102.149Z",
    transform: "translate(0 -93.782)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(1392.638 525.335)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.232,
    y: 0
  }, "Gift")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGiftcard);
export default __webpack_public_path__ + "static/media/icon-giftcard.00a145b3adabb01d96a372b6e47d2f20.svg";
export { ForwardRef as ReactComponent };